import React, { useRef, useEffect } from 'react';
import Quagga from 'quagga';

const BarcodeScanner = ({ setBarcode }) => {
    const videoRef = useRef(null);
    const quaggaInitialized = useRef(false);
    const quaggaRef = useRef(null); // Reference to Quagga instance

    useEffect(() => {
        const initCamera = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    Quagga.init({
                        inputStream: {
                            name: "Live",
                            type: "LiveStream",
                            target: videoRef.current,
                            constraints: {
                                width: { min: 640 },
                                height: { min: 480 },
                                facingMode: "environment",
                            },
                        },
                        locator: {
                            patchSize: "medium",
                            halfSample: true,
                        },
                        numOfWorkers: 2,
                        decoder: {
                            readers: ["ean_reader", "upc_reader", "code_128_reader"],
                        },
                        locate: true,
                    }, (err) => {
                        if (err) {
                            console.error("Error initializing Quagga:", err);
                            return;
                        }
                        quaggaInitialized.current = true;
                        Quagga.onDetected(handleBarcode);
                        if (quaggaInitialized.current) {
                            quaggaRef.current = Quagga; // Store Quagga instance in ref
                            Quagga.start();
                        }
                    });
                }
            } catch (error) {
                console.error("Error accessing the camera:", error);
            }
        };

        if (!quaggaInitialized.current) {
            initCamera();
        }

        return () => {
            if (quaggaInitialized.current) {
                quaggaRef.current && quaggaRef.current.stop(); // Stop Quagga if initialized
                quaggaRef.current = null;
                Quagga.offDetected(handleBarcode);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Ensure effect runs when scanning state changes

    const handleBarcode = (data) => {
        setBarcode(data.codeResult.code);
    };

    return (
        <div>
            <video ref={videoRef} autoPlay playsInline style={{ width: '100%', maxWidth: '300px', margin: 'auto', backgroundColor: 'black' }} />
        </div>
    )
}

export default BarcodeScanner;
